export default __webpack_public_path__ + "static/media/001-weightlifting.18089289.svg";